module.exports = __webpack_public_path__ + "static/media/multi.e017abf5.png";